<template>
  <input-text
    v-model="dataValue"
    v-bind="$attrs"
    :prefix="prefix"
    @blur="setValue($event)"
  />
</template>

<script>

export default {
  name: 'InputMoney',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    prefix: {
      type: String,
      default: 'R$',
    },
  },
  computed: {
    dataValue: {
      get() {
        return this.formatCurrency(
          this.value,
        );
      },
      set(value) {
        return value;
      },
    },
    setValue() {
      return (ev) => {
        const { value } = ev.target;
        this.$emit('input', value.replace(',', '.'));
      };
    },
  },
  methods: {
    formatCurrency(value) {
      const currencyToNumber = Number(parseFloat(value) || 0);
      const currency = currencyToNumber.toFixed(2).split('.');
      currency[0] = ''.concat(currency[0].split(/(?=(?:...)*$)/).join('.'));
      return currency.join(',');
    },
    onlyNumbers(value = '') {
      return value.replace(/[^0-9]/g, '');
    },
  },
};
</script>
